(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('vl-hover-zoom')) return;

    // Desktop hover zoom: a lens follows the cursor over the product image and a
    // magnified view of that area appears beside the gallery, over the product details.
    class VLHoverZoom extends HTMLElement {
      connectedCallback() {
        this.gallery = this.parentElement; // stable media column; the gallery inside it is replaced on variant change
        if (!this.gallery) return;
        this.mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
        this.scale = Math.min(5, Math.max(1.5, parseFloat(this.dataset.scale) || 2.5));
        this.lens = document.createElement('div');
        this.lens.className = 'vl-hz-lens';
        this.pane = document.createElement('div');
        this.pane.className = 'vl-hz-pane';
        document.body.append(this.lens, this.pane);
        this.onMove = this.onMove.bind(this);
        this.hide = this.hide.bind(this);
        this.gallery.addEventListener('pointermove', this.onMove);
        this.gallery.addEventListener('pointerleave', this.hide);
        this.gallery.addEventListener('click', this.hide);
        window.addEventListener('scroll', this.hide, { passive: true });
        window.addEventListener('resize', this.hide);
      }

      disconnectedCallback() {
        if (!this.gallery) return;
        this.gallery.removeEventListener('pointermove', this.onMove);
        this.gallery.removeEventListener('pointerleave', this.hide);
        this.gallery.removeEventListener('click', this.hide);
        window.removeEventListener('scroll', this.hide);
        window.removeEventListener('resize', this.hide);
        this.lens.remove();
        this.pane.remove();
      }

      hide() {
        if (!this.lens) return;
        this.lens.classList.remove('is-on');
        this.pane.classList.remove('is-on');
      }

      hiRes(src) {
        try {
          const u = new URL(src, window.location.href);
          u.searchParams.set('width', '2400');
          u.searchParams.delete('height');
          u.searchParams.delete('crop');
          return u.toString();
        } catch (e) {
          return src;
        }
      }

      onMove(e) {
        if (!this.mq.matches || e.pointerType !== 'mouse') return this.hide();
        const img = e.target instanceof Element ? e.target.closest('img.product-media__image') : null;
        if (!img || img.closest('dialog') || !img.complete || !img.naturalWidth) return this.hide();

        const r = img.getBoundingClientRect();
        const x = e.clientX - r.left;
        const y = e.clientY - r.top;
        if (x < 0 || y < 0 || x > r.width || y > r.height) return this.hide();

        // Place the pane beside the media column, on whichever side has room
        const col = this.gallery.closest('.product-information__media') || this.gallery;
        const c = col.getBoundingClientRect();
        const gap = 16;
        const onRight = c.left + c.width / 2 < window.innerWidth / 2;
        const room = onRight ? window.innerWidth - c.right - gap * 2 : c.left - gap * 2;
        const pw = Math.min(r.width * 1.1, room);
        const ph = r.height;
        if (pw < 240) return this.hide();
        const left = onRight ? c.right + gap : c.left - gap - pw;

        // Size of the picture inside the img box (object-fit: cover / contain / fill)
        const fit = getComputedStyle(img).objectFit;
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        let rw = r.width;
        let rh = r.height;
        if (fit === 'cover' || fit === 'contain') {
          const k = fit === 'cover' ? Math.max(r.width / nw, r.height / nh) : Math.min(r.width / nw, r.height / nh);
          rw = nw * k;
          rh = nh * k;
        }
        const ox = (r.width - rw) / 2;
        const oy = (r.height - rh) / 2;

        const z = this.scale * 1.3; // 1.3 = smaller lens (about 25%) for a closer look
        const lw = Math.min(pw / z, r.width);
        const lh = Math.min(ph / z, r.height);
        const lx = Math.max(0, Math.min(x - lw / 2, r.width - lw));
        const ly = Math.max(0, Math.min(y - lh / 2, r.height - lh));

        const src = img.currentSrc || img.src;
        if (src !== this.src) {
          this.src = src;
          this.pane.style.backgroundImage = 'url("' + this.hiRes(src) + '"), url("' + src + '")';
        }
        const size = rw * z + 'px ' + rh * z + 'px';
        const pos = (ox - lx) * z + 'px ' + (oy - ly) * z + 'px';
        this.pane.style.backgroundSize = size + ', ' + size;
        this.pane.style.backgroundPosition = pos + ', ' + pos;
        Object.assign(this.pane.style, { left: left + 'px', top: r.top + 'px', width: pw + 'px', height: ph + 'px' });
        Object.assign(this.lens.style, {
          left: r.left + lx + 'px',
          top: r.top + ly + 'px',
          width: lw + 'px',
          height: lh + 'px',
        });
        this.lens.classList.add('is-on');
        this.pane.classList.add('is-on');
      }
    }

    customElements.define('vl-hover-zoom', VLHoverZoom);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vl-frequently-bought"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('vl-fbt')) return;
  const money = (cents, f) => {
    f = f || '{{amount}}';
    const a = f.indexOf('{{'), b = f.indexOf('}}');
    const key = a > -1 && b > a ? f.slice(a + 2, b).trim() : 'amount';
    const g = (p, t, d) => {
      const parts = (Math.abs(cents) / 100).toFixed(p).split('.');
      let i = parts[0], o = '';
      while (i.length > 3) { o = t + i.slice(-3) + o; i = i.slice(0, -3); }
      o = i + o;
      return parts[1] ? o + d + parts[1] : o;
    };
    const m = {
      amount: g(2, ',', '.'), amount_no_decimals: g(0, ',', '.'),
      amount_with_comma_separator: g(2, '.', ','), amount_no_decimals_with_comma_separator: g(0, '.', ','),
      amount_with_apostrophe_separator: g(2, "'", '.'), amount_no_decimals_with_space_separator: g(0, ' ', ','),
      amount_with_space_separator: g(2, ' ', ','), amount_with_period_and_space_separator: g(2, ' ', '.')
    };
    const out = a > -1 && b > a ? f.slice(0, a) + (m[key] || m.amount) + f.slice(b + 2) : m.amount;
    const tmp = document.createElement('div'); tmp.innerHTML = out; return tmp.textContent;
  };
  const norm = (s) => String(s || '').toLowerCase().replace(/[_\-]+/g, ' ').replace(/\s+/g, ' ').trim();
  const reEsc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const COLOUR = /colou?r|shade/i;
  const MAIN = 'variant-picker[data-template-product-match="true"]';

  class VLFbt extends HTMLElement {
    connectedCallback() {
      if (this._ready) return; this._ready = true;
      this.fmt = this.dataset.money;
      this.btn = this.querySelector('[data-add]');
      this.err = this.querySelector('[data-error]');
      this.items = [...this.querySelectorAll('[data-item]')].map((el) => {
        let d = { variants: [], images: [], names: [] };
        try { d = Object.assign(d, JSON.parse(el.querySelector('[data-data]').textContent)); } catch (e) {}
        const it = {
          el, d,
          v: d.variants.find((x) => x.id == d.initial) || d.variants[0] || null,
          cb: el.querySelector('[data-check]'),
          sels: [...el.querySelectorAll('select[data-opt]')],
          sw: [...el.querySelectorAll('[data-swopt]')],
          img: el.querySelector('[data-img]'),
          ci: d.names.findIndex((n) => COLOUR.test(n))
        };
        it.sels.forEach((s) => s.addEventListener('change', () => this.pick(it, +s.dataset.opt, s.value)));
        it.sw.forEach((g) => g.addEventListener('click', (e) => {
          const b = e.target.closest('[data-value]');
          if (b) this.pick(it, +g.dataset.swopt, b.dataset.value);
        }));
        if (it.cb) it.cb.addEventListener('change', () => { el.classList.toggle('is-off', !it.cb.checked); this.total(); });
        return it;
      });
      this.cur = this.items.find((i) => i.el.hasAttribute('data-current')) || null;
      this.fromMain();
      this.matchColour(false);
      this.items.forEach((it) => this.paint(it));
      if (this.btn) this.btn.addEventListener('click', () => this.add());

      // Main product picker changed: follow its colour (and other options) on every row.
      this.onMainChange = (e) => {
        const t = e.target;
        if (!(t instanceof Element) || this.contains(t) || !t.closest(MAIN)) return;
        if (this.fromMain(true)) this.matchColour(true);
      };
      document.addEventListener('change', this.onMainChange);
      // Older theme event, kept for compatibility.
      this.onVariant = (e) => {
        const r = e.detail && (e.detail.resource || e.detail.variant);
        const id = r && r.id, cur = this.cur;
        if (!id || !cur) return;
        const v = cur.d.variants.find((x) => x.id == id);
        if (v && v !== cur.v) { cur.v = v; this.paint(cur); this.matchColour(true); }
      };
      document.addEventListener('variant:update', this.onVariant);
      this.total();
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onMainChange);
      document.removeEventListener('variant:update', this.onVariant);
    }
    mainPicker() { return document.querySelector(MAIN); }
    // Read the options currently chosen in the main picker into the "This item" row.
    fromMain(repaint) {
      const cur = this.cur, pk = this.mainPicker();
      if (!cur || !pk) return false;
      const sel = {};
      pk.querySelectorAll('fieldset input:checked').forEach((x) => { if (x.dataset.optionName) sel[norm(x.dataset.optionName)] = x.value; });
      pk.querySelectorAll('select').forEach((s) => { const o = s.selectedOptions[0]; if (o && o.dataset.optionName) sel[norm(o.dataset.optionName)] = s.value; });
      if (!Object.keys(sel).length) return false;
      const o = cur.d.names.map((n, k) => (sel[norm(n)] !== undefined ? sel[norm(n)] : (cur.v ? cur.v.options[k] : '')));
      const v = this.find(cur, o) || (cur.ci > -1 ? cur.d.variants.find((x) => x.options[cur.ci] === o[cur.ci]) : null);
      if (!v) return false;
      if (v !== cur.v) { cur.v = v; if (repaint) this.paint(cur); }
      return true;
    }
    // "This item" colour changed inside the box: move the main picker too.
    syncMain(val) {
      const pk = this.mainPicker(); if (!pk) return;
      const want = norm(val);
      const inp = [...pk.querySelectorAll('input[data-option-name]')].find((x) => COLOUR.test(x.dataset.optionName) && norm(x.value) === want);
      if (inp) { if (!inp.checked) inp.click(); return; }
      const sel = [...pk.querySelectorAll('select')].find((s) => s.options[0] && COLOUR.test(s.options[0].dataset.optionName || ''));
      if (sel) {
        const op = [...sel.options].find((x) => norm(x.value) === want);
        if (op && sel.value !== op.value) { sel.value = op.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    // Every suggested row switches to the main product's colour, ticked or not.
    matchColour(repaint) {
      if (!this.hasAttribute('data-match-colour')) return;
      const cur = this.cur;
      if (!cur || !cur.v || cur.ci < 0) return;
      const col = norm(cur.v.options[cur.ci]);
      if (!col) return;
      this.items.forEach((it) => {
        if (it === cur || it.ci < 0) return;
        const cands = it.d.variants.filter((x) => norm(x.options[it.ci]) === col);
        if (!cands.length) return;
        const keep = it.v ? it.v.options : [];
        const v = cands.find((x) => x.available && x.options.every((y, k) => k === it.ci || y === keep[k]))
          || cands.find((x) => x.available) || cands[0];
        if (v === it.v) return;
        it.v = v;
        if (repaint) this.paint(it);
      });
    }
    find(it, o) { return it.d.variants.find((x) => x.options.every((y, i) => y === o[i])) || null; }
    pick(it, i, val) {
      const base = it.v || it.d.variants[0];
      if (!base) return;
      const o = [...base.options]; o[i] = val;
      let v = this.find(it, o);
      if (!v || !v.available) {
        v = it.d.variants.find((x) => x.options[i] === val && x.available) || v || it.d.variants.find((x) => x.options[i] === val) || null;
      }
      it.v = v; this.paint(it);
      if (it === this.cur && i === it.ci) { this.matchColour(true); this.syncMain(val); }
    }
    image(it) {
      const v = it.v;
      if (!v) return it.d.image;
      if (it.ci > -1) {
        const val = norm(v.options[it.ci]);
        if (val) {
          const re = new RegExp('(^|[^a-z0-9])' + reEsc(val) + '([^a-z0-9]|$)');
          const m = it.d.images.find((x) => re.test(norm(x.key)));
          if (m) return m.src;
        }
      }
      if (v.image) return v.image;
      return it.d.image;
    }
    paint(it) {
      const v = it.v, ok = !!(v && v.available), el = it.el;
      it.sels.forEach((s) => {
        const i = +s.dataset.opt;
        if (v) s.value = v.options[i];
        [...s.options].forEach((op) => {
          const o = v ? [...v.options] : [];
          o[i] = op.value;
          const m = this.find(it, o);
          op.textContent = op.value + (m && m.available ? '' : ' (' + (this.dataset.soldout || 'Sold out') + ')');
        });
      });
      it.sw.forEach((g) => {
        const i = +g.dataset.swopt;
        const lbl = g.querySelector('[data-sw-current]'); if (lbl) lbl.textContent = v ? v.options[i] : '';
        g.querySelectorAll('[data-value]').forEach((b) => {
          b.setAttribute('aria-pressed', v && b.dataset.value === v.options[i] ? 'true' : 'false');
          const o = v ? [...v.options] : [];
          o[i] = b.dataset.value;
          const m = this.find(it, o);
          b.classList.toggle('is-unavailable', !(m && m.available));
        });
      });
      const p = el.querySelector('[data-price]'); if (p) p.textContent = v ? money(v.price, this.fmt) : '';
      const c = el.querySelector('[data-compare]');
      if (c) { const s = !!(v && v.compare > v.price); c.hidden = !s; if (s) c.textContent = money(v.compare, this.fmt); }
      const so = el.querySelector('[data-soldout]'); if (so) so.hidden = ok;
      if (it.cb) { it.cb.disabled = !ok; if (!ok) it.cb.checked = false; el.classList.toggle('is-off', !it.cb.checked); }
      const src = this.image(it);
      if (it.img && src && it.img.getAttribute('src') !== src) { it.img.removeAttribute('srcset'); it.img.src = src; }
      this.total();
    }
    selected() { return (this.items || []).filter((i) => i.cb && i.cb.checked && i.v && i.v.available); }
    total() {
      if (!this.items) return;
      const s = this.selected();
      const t = s.reduce((a, i) => a + i.v.price, 0);
      const c = s.reduce((a, i) => a + Math.max(i.v.price, i.v.compare || 0), 0);
      const te = this.querySelector('[data-total]'); if (te) te.textContent = money(t, this.fmt);
      const ce = this.querySelector('[data-total-compare]'); if (ce) { ce.hidden = !(c > t); ce.textContent = money(c, this.fmt); }
      if (this.btn && !this.busy) { this.btn.disabled = !s.length; this.btn.textContent = this.dataset.label; }
    }
    async add() {
      const s = this.selected();
      if (!s.length || this.busy) return;
      this.busy = true;
      const b = this.btn; b.disabled = true; b.textContent = this.dataset.adding;
      if (this.err) this.err.hidden = true;
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        if (window.Shopify && Shopify.actions && typeof Shopify.actions.updateCart === 'function') {
          const r = await Shopify.actions.updateCart({ lines: s.map((i) => ({ merchandiseId: 'gid://shopify/ProductVariant/' + i.v.id, quantity: 1 })) });
          if (r && r.userErrors && r.userErrors.length) throw new Error(r.userErrors[0].message);
          b.textContent = this.dataset.added;
          setTimeout(() => { this.busy = false; this.total(); }, 1800);
        } else {
          const r = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: s.map((i) => ({ id: i.v.id, quantity: 1 })) })
          });
          const j = await r.json().catch(() => ({}));
          if (!r.ok) throw new Error(j.description || j.message || this.dataset.error);
          window.location.href = root + 'cart';
        }
      } catch (e) {
        if (this.err) { this.err.textContent = (e && e.message) || this.dataset.error; this.err.hidden = false; }
        this.busy = false; this.total();
      }
    }
  }
  customElements.define('vl-fbt', VLFbt);
})();
  } catch(e) { console.error(e); }
})();

})();
